module.exports = __webpack_public_path__ + "fonts/iconfont.55cd7138.ttf";